import { Component, effect, inject, signal } from '@angular/core';
import { TreeRootComponent } from '../tree-root/tree-root.component';
import { TreeItemService } from '../../../../shared/services/tree-item.service';
import { MaterialModule } from '../../../../modules/material.module';
import { Router } from '@angular/router';
import {
  IActionMapping,
  ITreeOptions,
  KEYS,
  TREE_ACTIONS,
} from '@ali-hm/angular-tree-component';

// a constant mapping various user input actions to tree behavior
const actionMapping: IActionMapping = {
  mouse: {
    click: (tree, node, $event) => {
      //to make node active and select
      setTimeout(() => {
        TREE_ACTIONS.TOGGLE_ACTIVE(tree, node, $event);
      }, 0);
    },
  },
  keys: {
    // pressing the Enter key
    [KEYS.ENTER]: (tree, node, $event) => alert(`This is ${node.data.title}`),
  },
};
@Component({
  selector: 'app-trash-items',
  imports: [TreeRootComponent, MaterialModule],
  templateUrl: './trash-items.component.html',
  styleUrl: './trash-items.component.scss',
})
export class TrashItemsComponent {
  protected treeItemService = inject(TreeItemService);
  private router = inject(Router);
  protected displayedTreeNodeTrashItems = signal<Array<any>>([]);

  constructor() {
    effect(() => {
      this.itemFilter();
    });
  }
  ngOnInit(): void {
    this.itemFilter();
  }

  itemFilter() {
    const items = this.treeItemService.allTreeNodeItems().filter((item) => item.in_trash)
    // convertToTreeStructure this function get all children items
    this.displayedTreeNodeTrashItems.set(this.treeItemService.convertToTreeStructure(items));
  }
  /**
   *  back to dashboard view
   */
  backToDashboard(): void {
    this.router.navigate(['']);
  }

  customTemplateOptions: ITreeOptions = {
    displayField: 'title',
    isExpandedField: 'subitems_expanded',
    idField: 'id', // node id field
    actionMapping,
    nodeHeight: 23, // allotted height of the entire tree
    useVirtualScroll: true,
    animateExpand: true,
    animateSpeed: 5,
    animateAcceleration: 1.05,
    allowDrag: (node) => {
      return false;
    },
    allowDrop: (node) => {
      return false;
    },
  };
}
